import type { TutorTaskPostponeDates } from '../../model/tutor-tasks/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface TutorTaskPostponeDatesApiOptions {
  taskId: number
  onStart?: () => void
  onFinish?: () => void
}

/** `GET /admin-api/tutor-tasks/{task}/postpone-dates` — `to: null` means the task cannot be postponed. */
export const useTutorTaskPostponeDatesApi = async (
  options: TutorTaskPostponeDatesApiOptions,
): Promise<TutorTaskPostponeDates | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.tutor-task.postpone-dates', { task_id: options.taskId })

  options.onStart?.()

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.get<ApiResponse>(url)

    return data.data ?? null
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return null
  } finally {
    options.onFinish?.()
  }
}
